import { Button, cn } from '@massilia/ui'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { toast } from 'sonner'

import { IdentificationLoginComponent } from '@/components/login/identification-login-component'
import { ReservationNumberLoginComponent } from '@/components/login/reservation-login-component'
import { toSafeRedirect } from '@/lib/safe-redirect'

export const Route = createFileRoute('/_auth/connexion')({
  component: LoginComponent,
  // Type optionnel volontaire : rendre `redirect` obligatoire forcerait les
  // onze `Link to="/connexion"` du site à le fournir.
  validateSearch: (search: Record<string, unknown>): { redirect?: string } =>
    typeof search.redirect === 'string' ? { redirect: search.redirect } : {},
})

const availableConnexionMethods = {
  identification: 'identification',
  pnr: 'pnr',
} as const

function LoginComponent() {
  const redirectTo = toSafeRedirect(Route.useSearch().redirect)
  const [connexionMethod, setConnexionMethod] = useState<keyof typeof availableConnexionMethods>(
    availableConnexionMethods.identification
  )
  const [prefilledEmail, setPrefilledEmail] = useState('')

  const handleAccountExists = (email: string) => {
    setPrefilledEmail(email)
    setConnexionMethod(availableConnexionMethods.identification)
    toast.info('Un compte existe déjà pour ce dossier.', {
      description: 'Connectez-vous avec votre mot de passe pour continuer.',
    })
  }

  return (
    <>
      <h1 className="text-gray-light-900 text-center text-xl font-semibold">
        Connectez-vous à votre compte <br /> Massilia Voyages
      </h1>
      <div className="bg-gray-light-50 flex w-full rounded-lg p-0.5">
        <button
          className={cn(
            'text-gray-light-600 flex-1 rounded-lg px-3 py-1.5 text-sm font-semibold',
            connexionMethod === availableConnexionMethods.identification &&
              'text-gray-light-900 bg-white'
          )}
          onClick={() => {
            setConnexionMethod(availableConnexionMethods.identification)
          }}
        >
          Avec vos identifiants
        </button>
        <button
          className={cn(
            'text-gray-light-600 flex-1 rounded-lg px-3 py-1.5 text-sm font-semibold',
            connexionMethod === availableConnexionMethods.pnr && 'text-gray-light-900 bg-white'
          )}
          onClick={() => {
            setConnexionMethod(availableConnexionMethods.pnr)
          }}
        >
          Avec le n° de dossier
        </button>
      </div>
      {connexionMethod === availableConnexionMethods.identification && (
        <IdentificationLoginComponent prefilledEmail={prefilledEmail} redirectTo={redirectTo} />
      )}
      {connexionMethod === availableConnexionMethods.pnr && (
        <ReservationNumberLoginComponent
          onAccountExists={handleAccountExists}
          redirectTo={redirectTo}
        />
      )}
      <Link to="/inscription">
        <Button className="text-brand-700 w-full hover:underline" variant="none">
          Je n&apos;ai pas encore de compte
        </Button>
      </Link>
    </>
  )
}
